import { LineItemReturnModel as LineItem, ProductCardModel, ProductModel } from '../services/client.generated';


export namespace instanceOf {
    export function lineItem(object: any): object is LineItem {

        return object != undefined &&
            'id' in object &&
            'name' in object &&
            // 'googleProductCategory' in object &&
            'productUrl' in object &&
            'totalPrice' in object &&
            'quantity' in object;
    }
    export function productCardModel(object: any): object is ProductCardModel {

        return object != undefined &&
            'id' in object &&
            'name' in object &&
            // 'googleProductCategory' in object &&
            'price' in object;
    }
    export function productModel(object: any): object is ProductModel {

        return object != undefined &&
            'id' in object &&
            'name' in object &&
            // 'googleProductCategory' in object &&
            'description' in object &&
            'price' in object;
    }
}
